<fgb-route-nav>
  <a
    class="nav-item leaderboard-nav-item"
    [routerLink]="['/games/' + routeLink]"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'game.nav.' + routeLink + '.screenreader' | translate }}"
  >
    {{ routeLink + '.nav.featured' | translate : { fgbdefault: 'Play' } }}
  </a>
  <a
    class="nav-item leaderboard-nav-item"
    [routerLink]="['/games/' + routeLink + '/leaderboard']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'game.nav.' + routeLink + '.leaderboard.screenreader' | translate }}"
  >
    {{ 'games.nav.' + routeLink + '.leaderboard' | translate : { fgbdefault: 'Leaderboard' } }}
  </a>
  <a
    *ngIf="isRulesEnabled"
    class="nav-item leaderboard-nav-item"
    [routerLink]="['/games/' + routeLink + '/how-to-play']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'game.nav.' + routeLink + '.rules.screenreader' | translate }}"
  >
    {{ 'games.nav.' + routeLink + '.how.to.play' | translate : { fgbdefault: 'How to Play' } }}
  </a>
</fgb-route-nav>
